var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 13.7501L15.18 14.6815C16.3362 15.0353 17.1951 15.9627 17.4803 17.0916C17.5929 17.5381 17.2074 17.9167 16.7447 17.9167H3.25533C2.79256 17.9167 2.40704 17.5381 2.51979 17.0916C2.80494 15.9627 3.66383 15.0353 4.82001 14.6815L7.91667 13.7501V12.1352C6.43263 10.9737 5.41667 9.58323 5.41667 6.59726C5.41667 3.60572 7.04562 2.08325 9.57692 2.08325C11.3694 2.08325 12.1154 2.91659 12.1154 2.91659C14.2308 2.91659 14.5833 4.66424 14.5833 6.59726C14.5833 9.58323 13.5673 10.9737 12.0833 12.1352V13.7501Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutives);
export default __webpack_public_path__ + "static/media/executives.23ae38475dfec945d7ab32936c695bd7.svg";
export { ForwardRef as ReactComponent };